import React, { Fragment, useEffect, useState } from "react"
import styled from "@emotion/styled"
import { injectIntl } from "gatsby-plugin-intl"
import { useLocation } from "@reach/router"
import { isBrowser } from "../../../context/ApolloContext"
import { isLoadedScript } from "../../../utils/additionalScriptHelpers"

import Header from "../Header"
import WelcomeBar from "../WelcomeBar"
import StickyMobileMenu from "../StickyMobileMenu"
import MotherEsStickyBanner from "../MotherEsStickyBanner"
import ExclusifStickyBanner from "../ExclusifStickyBanner"
import ChristmasStickyBanner from "../ChristmasStickyBanner"
import OfferStickyBanner from "../OfferStickyBanner"
import ChristmasGbpStickyBanner from "../ChristmasGbpStickyBanner"
import RentreeStickyBanner from "../RentreeStickyBanner"
import CartErrorBanner from "../CartErrorBanner"
import BlackFridayGbpStickyBanner from "../BlackFridayGbpStickyBanner"
import BlackFridayStickyBanner from "../BlackFridayStickyBanner"
import FlashStickyBanner from "../FlashStickyBanner"
import FlashGbpStickyBanner from "../FlashGbpStickyBanner"
import OffreFlashStickyBanner from "../OffreFlashStickyBanner"
import MotherFrStickyBanner from "../MotherFrStickyBanner"
import MotherEnStickyBanner from "../MotherEnStickyBanner"
import MotherDeStickyBanner from "../MotherDeStickyBanner"

const $ = isBrowser ? require("jquery") : {}

const HeaderSection = ({
  intl,
  children,
  exclusifPromo,
  isIdealPage,
  isNotCartPage,
  isNotLyneupExclusifPage,
}) => {
  const [hideStickyMenu, setHideStickyMenu] = useState(false)

  const { pathname } = useLocation()

  const handleHeaderVisiblity = () => {
    var navbar = document.getElementById("topHeader")
    var navBarHeight = navbar.offsetHeight
    var prevScrollPos = window.pageYOffset

    window.onscroll = function () {
      var currentScrollPos = window.pageYOffset

      // Scroll down
      if (prevScrollPos < currentScrollPos && currentScrollPos > navBarHeight) {
        navBarHeight = navbar.offsetHeight
        document.body.classList.add("headerSticky")
        let header = document.getElementById("scrollUPHeader")
        if (header && header?.style) {
          header.style.transform = "translateY(-" + navBarHeight + "px)"
        }
      } else {
        // Scroll up
        document.body.classList.remove("headerSticky")
        let header = document.getElementById("scrollUPHeader")
        if (header && header?.style) {
          header.style.transform = "unset"
        }
      }

      prevScrollPos = currentScrollPos
    }
  }

  const pageUrlHandler = () => {
    let currentPath = ""

    let hideStickyRegex =
      /(dispositif-medical|lyneup|notre-histoire|ils-nous-aiment|nos-revendeurs|shop|back-health|les-maux-de-dos)/

    currentPath = window.location.pathname

    if (
      pathname === "/" ||
      pathname === `/${intl.locale}/` ||
      pathname === `/${process.env.GATSBY_CURRENCY_TYPE}/` ||
      pathname === `/${process.env.GATSBY_CURRENCY_TYPE}/${intl.locale}/` ||
      hideStickyRegex.test(currentPath)
    )
      setHideStickyMenu(false)
    else setHideStickyMenu(true)
  }

  useEffect(() => {
    pageUrlHandler()
    isBrowser && handleHeaderVisiblity()
  }, [pathname])

  const CookieBotHeadScript = () => {
    let srcUrl =
      "https://consent.cookiebot.com/uc.js?cbid=9fc0fb92-43df-488b-a53e-b99e0a67c9ba"
    if (!isLoadedScript(srcUrl)) {
      const script = document.createElement("script")
      script.src = srcUrl
      script.id = "Cookiebot"
      script.type = "text/javascript"
      script.setAttribute("data-blockingmode", "auto")
      script.setAttribute("data-culture", intl.locale)
      document.head.appendChild(script)
    }
  }

  useEffect(() => {
    // isBrowser && CookieBotHeadScript()
  }, [])

  return (
    <HeaderSectionWrapper id="scrollUPHeader">
      <TopHeader id="topHeader">
        {children}
        {isIdealPage && <WelcomeBar exclusifPromo={exclusifPromo} />}
        {isIdealPage && <Header exclusifPromo={exclusifPromo} />}
      </TopHeader>
      <BottomHeader id="bottomHeader">
        {/* {(process.env.GATSBY_ACTIVE_ENV === "eur" ||
          process.env.GATSBY_ACTIVE_ENV === "general") &&
          intl.locale === "fr" &&
          isIdealPage &&
          isNotCartPage &&
          isNotLyneupExclusifPage && <ChristmasStickyBanner />} */}
        {/* {(process.env.GATSBY_ACTIVE_ENV === "eur" ||
          process.env.GATSBY_ACTIVE_ENV === "general") &&
          intl.locale === "fr" &&
          isIdealPage &&
          isNotCartPage &&
          isNotLyneupExclusifPage && <OfferStickyBanner />} */}
        {(process.env.GATSBY_ACTIVE_ENV === "eur" ||
          process.env.GATSBY_ACTIVE_ENV === "general") &&
          intl.locale === "fr" &&
          isNotLyneupExclusifPage &&
          isIdealPage &&
          isNotCartPage && <OffreFlashStickyBanner />}
        {/* {(process.env.GATSBY_ACTIVE_ENV === "eur" ||
          process.env.GATSBY_ACTIVE_ENV === "general") &&
          intl.locale === "fr" &&
          isIdealPage &&
          isNotCartPage && 
          isNotLyneupExclusifPage && <FlashStickyBanner />} */}
        {/* {(process.env.GATSBY_ACTIVE_ENV === "eur" ||
          process.env.GATSBY_ACTIVE_ENV === "general") &&
          intl.locale === "fr" &&
          isIdealPage &&
          isNotCartPage && 
          isNotLyneupExclusifPage && <RentreeStickyBanner />} */}
        {/* {(process.env.GATSBY_ACTIVE_ENV === "eur" ||
          process.env.GATSBY_ACTIVE_ENV === "general") &&
          intl.locale === "fr" &&
          isIdealPage &&
          isNotCartPage &&
          isNotLyneupExclusifPage && <BlackFridayStickyBanner />} */}
        {process.env.GATSBY_ACTIVE_ENV === "gbp" &&
          isIdealPage &&
          isNotCartPage &&
          isNotLyneupExclusifPage && <ChristmasGbpStickyBanner />}
        {/* {process.env.GATSBY_ACTIVE_ENV === "gbp" &&
          isIdealPage &&
          isNotCartPage && 
          isNotLyneupExclusifPage && <FlashGbpStickyBanner />} */}
        {/* {process.env.GATSBY_ACTIVE_ENV === "gbp" &&
          isIdealPage &&
          isNotCartPage && 
          isNotLyneupExclusifPage && <BlackFridayGbpStickyBanner />} */}
        {(process.env.GATSBY_ACTIVE_ENV === "eur" ||
          process.env.GATSBY_ACTIVE_ENV === "general") &&
          intl.locale === "fr" &&
          exclusifPromo === "top-exclu" &&
          isIdealPage &&
          isNotCartPage &&
          !isNotLyneupExclusifPage && <ExclusifStickyBanner />}
        {intl.locale === "es" &&
          isIdealPage &&
          isNotCartPage &&
          isNotLyneupExclusifPage && <MotherEsStickyBanner />}
        {intl.locale === "de" &&
          isIdealPage &&
          isNotCartPage &&
          isNotLyneupExclusifPage && <MotherDeStickyBanner />}
        {process.env.GATSBY_ACTIVE_ENV != "gbp" &&
          intl.locale === "en" &&
          isIdealPage &&
          isNotCartPage &&
          isNotLyneupExclusifPage && <MotherEnStickyBanner />}
        {process.env.GATSBY_ACTIVE_ENV === "cad" &&
          intl.locale === "fr" &&
          isIdealPage &&
          isNotCartPage &&
          isNotLyneupExclusifPage && <MotherFrStickyBanner />}
        {intl.locale === "en" &&
          hideStickyMenu &&
          isIdealPage &&
          isNotCartPage &&
          isNotLyneupExclusifPage && <StickyMobileMenu />}
        {/* <CartErrorBanner /> */}
      </BottomHeader>
    </HeaderSectionWrapper>
  )
}

const HeaderSectionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  position: sticky;
  top: 0px;
  z-index: 5;
  transition: all 0.5s;
`

const TopHeader = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  position: relative;
  transition: all 0.5s;
`

const BottomHeader = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  position: relative;
`

export default injectIntl(HeaderSection)
